import type { Store } from '@ms/yammer-data/dist/state/types';
import Main from 'components/Main';
import React from 'react';
import { createRoot } from 'react-dom/client';
import type { YammerTeamsState } from 'state/types';

interface RendererOptions {
  readonly store: Store<YammerTeamsState>;
  readonly target: HTMLElement;
  readonly error?: unknown;
  readonly etag?: string;
}

export type Renderer = (options: RendererOptions) => void;

const renderer: Renderer = ({ store, target, error, etag }) => {
  const root = createRoot(target);
  root.render(<Main store={store} error={error} etag={etag} />);
};

export default renderer;
